import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";


// ==== GENERATOR ====

export function generateTask() {
  const n1 = Math.floor(Math.random() * 5) + 2; // >=2
  const k = Math.floor(Math.random() * 3) + 2; // >=2
  const n2 = n1 + k;

  const a1 = Math.floor(Math.random() * 10) - 5; // a1
  const r = Math.floor(Math.random() * 6) - 3;   // r != 0
  const a_n1 = a1 + (n1 - 1) * r;
  const a_n2 = a1 + (n2 - 1) * r;

  return {
    type: "FindA1AndRTask",
    data: { n1, n2, a_n1, a_n2, a1, r }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { n1, a_n1, n2, a_n2 } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny, w którym{" "}
        <InlineMath math={`a_{${n1}} = ${a_n1}`} /> oraz{" "}
        <InlineMath math={`a_{${n2}} = ${a_n2}`} />.
      </p>
      <p>
        Oblicz <InlineMath math="a_1" /> i <InlineMath math="r" /> tego ciągu.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <InlineMath math="a_1 =" />
        <FractionInput
          value={userAnswer?.a1 || ""}
          onChange={(val) => onChange({ ...userAnswer, a1: val })}
          disabled={disabled}
          label="a_1"
        />
      </div>
      <div className="flex items-center gap-2">
        <InlineMath math="r =" />
        <FractionInput
          value={userAnswer?.r || ""}
          onChange={(val) => onChange({ ...userAnswer, r: val })}
          disabled={disabled}
          label="r"
        />
      </div>
    </div>
  );
}



export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;

  const a1Given = userAnswer.a1?.parsed;
  const rGiven = userAnswer.r?.parsed;

  if (a1Given === null || rGiven === null) return false;

  return (
    Math.abs(a1Given - data.a1) < 0.01 &&
    Math.abs(rGiven - data.r) < 0.01
  );
}


export function renderAnswer({ data }) {
  return (
    <InlineMath math={`a_1 = ${data.a1},\\ r = ${data.r}`} />
  );
}

export function renderExplanation({ data }) {
  const { n1, n2, a_n1, a_n2, a1, r } = data;

  const deltaN = n2 - n1;
  const deltaA = a_n2 - a_n1;
  const computedR = deltaA / deltaN;
  const computedA1 = a_n1 - (n1 - 1) * computedR;

  const formattedDeltaA = deltaA < 0 ? `(${deltaA})` : `${deltaA}`;
  const formattedR = computedR < 0 ? `(${computedR})` : `${computedR}`;

  const formatForExpression = (val, operator = '') => {
    if (val < 0 && operator) {
      return `(${val})`;
    }
    return `${val}`;
  };

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Układ równań dla dwóch wyrazów:
      </p>
      <BlockMath math={`a_{${n1}} = a_1 + (${n1}-1) \\cdot r = ${a_n1}`} />
      <BlockMath math={`a_{${n2}} = a_1 + (${n2}-1) \\cdot r = ${a_n2}`} />

      <p>
        <strong>Krok 2:</strong> Odejmujemy równania, aby znaleźć <InlineMath math="r" />:
      </p>
      <BlockMath math={`r = \\frac{${a_n2} - ${formatForExpression(a_n1, '-')}}{${n2} - ${n1}}`} />
      <BlockMath math={`r = \\frac{${formattedDeltaA}}{${deltaN}} = ${formattedR}`} />

<p>
  <strong>Krok 3:</strong> Podstawiamy <InlineMath math="r" /> do równania dla <InlineMath math={`a_{${n1}}`} /> i obliczamy <InlineMath math="a_1" />:
</p>
<BlockMath math={`a_1 = ${a_n1} - (${n1}-1) \\cdot ${formattedR}`} />
<BlockMath math={`a_1 = ${a_n1} - ${(n1 - 1) * computedR}`} />
<BlockMath math={`a_1 = ${computedA1}`} />

    </div>
  );
}


export function renderUserAnswer(userAnswer) {
  if (
    !userAnswer ||
    typeof userAnswer !== "object" ||
    (!userAnswer.a1?.raw && !userAnswer.r?.raw)
  ) {
    return <i>(brak odpowiedzi)</i>;
  }

  return (
    <InlineMath
      math={`a_1 = ${userAnswer.a1?.raw || "?"},\\ r = ${userAnswer.r?.raw || "?"}`}
    />
  );
}
